<template>
  <div
    class="price-info"
    :class="{
      'price-info--reduction': value.old
    }"
  >
    <div
      class="product-navigation-price-info__old price-info__old"
      v-if="value.old"
    >
      <span class="price-info__old-text">{{ $t('price.instead_of') }}</span>
      <span class="price-info__old-value">
        <span class="price-info__old-value-currency">
          {{ value.currency }}
        </span>
        <span class="price-info__old-value-price">
          {{ oldValue }}
        </span>
      </span>
    </div>

    <div
      class="product-navigation-price-info__current price-info__current"
      :class="{
        'price-info__current--no-discount': !value.old
      }"
    >
      <span class="price-info__currency">
        {{ value.currency }}
      </span>
      <span class="price-info__value product-navigation-price-info__value">
        {{ value.currentValue }}
      </span>
      <span
        v-if="showStar"
        class="price-info__asterisk"
      >
        *
      </span>
      <span
        class="product-navigation-price-info__savedPercentage price-info__savedPercentage price-info--savings-max"
        v-if="value.savedPercentage && withSavingsMax && value.savedPercentage > 50"
        v-html="$t('product.price.savedPercentage.savingsMax')"
      />
      <span
        class="product-navigation-price-info__savedPercentage price-info__savedPercentage"
        v-else-if="value.savedPercentage"
      >
        -{{ value.savedPercentage }}%
      </span>
    </div>

    <div class="price-info__unit-wrapper">
      <div class="product-navigation-price-info__unit price-info__unit">
        <span class="product-navigation-price-info__unit-text price-info__unit-text">
          {{ getUnitText() }}
        </span>
        <span
          v-if="value.unitPrice"
          class="product-navigation-price-info__unit-price price-info__unit-price"
        >
          {{ value.unitPrice }}<template v-if="value.unit">/{{ value.unit }}</template>
        </span>
      </div>
      <div
        v-if="showTax"
        class="product-navigation-price-info__tax"
        v-html="$t(showShippingIncluded ? messageKey.deliveryInclShip : messageKey.deliveryInclVat, [shippingInfoUrl])"
      />
    </div>
  </div>
</template>

<script>
  import PriceInfo from '../priceInfo/priceInfo.vue';
  export default {
    name: 'ProductNavigationPriceInfo',
    extends: PriceInfo,
  }
</script>
